import Pitch from "./Pitch"
import SelectPlayers from "./SelectPlayers"
import "./grey-box.sass"
import styled from "styled-components"
import MatchDetailsPitch from "./MatchDetailsPitch"
import { useLeague } from "../../../context/useLeague"
import { FC } from "react"
import { useUser } from "../../../context/useUser"

const Lineup: FC = ({}) => {
  const { lineup, manager } = useLeague()
  const { user } = useUser()

  return (
    <>
      <div className='container d-flex flex-column flex-lg-row justify-content-center  align-items-start gap-lg-4 gap-0 mb-3 w-100 h-100'>
        <>
          <PitchContainer>
            <MatchDetailsPitch />
            <Pitch lineupPositions={lineup} playerClickedRemovesThem={true} />
          </PitchContainer>

          {manager && user && manager._id === user._id ? (
            <RightColumn>
              <SelectPlayers />
            </RightColumn>
          ) : null}
        </>
      </div>
    </>
  )
}
export default Lineup
const PitchContainer = styled.div`
  width: 100%;
  max-width: 450px;
  height: 100%;
`
const RightColumn = styled.div`
  width: 100%;
  height: 84%;
  max-width: 450px;
  display: flex;
  justify-content: flex-end;
  margin-top: -16px;
  overflow: visible;

  @media (max-width: 991px) {
    height: 100%;
  }

  @media (max-width: 576px) {
    height: 100%;
  }
`
